// extracted by mini-css-extract-plugin
export var errormessage = "FormTextArea-module--errormessage--2f418";
export var textarea = "FormTextArea-module--textarea--6a382";
export var textarealabel = "FormTextArea-module--textarealabel--a6497";
export var textareawrapper = "FormTextArea-module--textareawrapper--ff539";